import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const PreferencesStep = ({ formData, errors, onChange, onCheckboxChange }) => {
  const communicationOptions = [
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'both', label: 'Email et SMS' }
  ];

  const frequencyOptions = [
    { value: 'daily', label: 'Quotidien' },
    { value: 'weekly', label: 'Hebdomadaire' },
    { value: 'biweekly', label: 'Bi-mensuel' },
    { value: 'monthly', label: 'Mensuel' }
  ];

  const notificationTypes = [
    { id: 'progress', label: 'Rapports de progression académique' },
    { id: 'achievements', label: 'Réalisations et badges gagnés' },
    { id: 'quiz', label: 'Résultats des quiz' },
    { id: 'recommendations', label: 'Nouvelles recommandations de filières' },
    { id: 'alerts', label: 'Alertes importantes' },
    { id: 'meetings', label: 'Invitations aux réunions' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-green-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">3</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Préférences de Communication
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Personnalisez la façon dont vous recevez les informations sur vos enfants.
            </p>
          </div>
        </div>
      </div>

      <Select
        label="Mode de Communication Préféré"
        options={communicationOptions}
        value={formData?.communicationPreference}
        onChange={(value) => onChange({ target: { name: 'communicationPreference', value } })}
        placeholder="Sélectionnez votre préférence"
        description="Comment souhaitez-vous recevoir les notifications ?"
        error={errors?.communicationPreference}
        required
      />

      <Select
        label="Fréquence des Rapports de Progression"
        options={frequencyOptions}
        value={formData?.reportFrequency}
        onChange={(value) => onChange({ target: { name: 'reportFrequency', value } })}
        placeholder="Sélectionnez la fréquence"
        description="À quelle fréquence souhaitez-vous recevoir les rapports détaillés ?"
        error={errors?.reportFrequency}
        required
      />

      <div>
        <CheckboxGroup 
          label="Types de Notifications" 
          error={errors?.notificationTypes}
        >
          <p className="text-sm text-gray-600 mb-3 md:mb-4">
            Sélectionnez les types de notifications que vous souhaitez recevoir
          </p>
          <div className="space-y-3">
            {notificationTypes?.map((type) => (
              <Checkbox
                key={type?.id}
                label={type?.label}
                checked={formData?.notificationTypes?.includes(type?.id)}
                onChange={(e) => onCheckboxChange('notificationTypes', type?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>

      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-blue-900 mb-1">Confidentialité et Sécurité</h4>
            <p className="text-sm text-blue-800">
              Vos données et celles de vos enfants sont protégées. Vous pouvez modifier ces préférences à tout moment depuis votre tableau de bord.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreferencesStep;